export const LeftMenuName = 'LeftMenuComponent';
